import superMeta from '../_COMMENT/metaCommentNode.mjs'

export default {
    ...superMeta,
    name: '标注',
    type: 'MARK',
}
